import { render, staticRenderFns } from "./DialogComponentFooter.vue?vue&type=template&id=050982a3&scoped=true&"
import script from "./DialogComponentFooter.vue?vue&type=script&lang=js&"
export * from "./DialogComponentFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050982a3",
  null
  
)

export default component.exports
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCardActions,QSpace,QBtn});qInstall(component, 'directives', {ClosePopup});
